<template>
  <v-flex>
    <v-container fluid grid-list-md>
      <v-card>
        <v-card-title>
          <h2 class="headline text-xs-center">Coming Soon</h2>
        </v-card-title>
        <v-card-text>
        </v-card-text>
      </v-card>
    </v-container>
  </v-flex>
</template>
<script>
export default {
  name: 'History'
}
</script>
